<template lang="html">
    <div>
        Error - Page Not Found
        <div
            @click="changePage"
            class="link"
        >Go to home page
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            changePage() {
                this.$router.push('/');
            },
        },
    };
</script>
<style lang="scss" scoped>
    .link{
        color: blue;
        cursor: pointer;
    }
</style>
